const COACH_TITLE_OPTIONS = ["Coach", "Assistant Coach", "Team Manager", "Other"];
const TEAM_REPRESENTATIVE_TITLE_OPTIONS = ["Team Representative", "Parent Representative", "Other"];

const DEFAULT_SEASON_TEAM_FIELDS = [
  {
    "name" : "Team Name",
    "fieldId" : "teamName",
    "required" : true,
    "helperText" : "",
    "include" : true,
    "fieldType" : "textbox",
    "primitiveType" : "string",
    "error" : {
        "name" : "",
        "helperText" : ""
    },
    "options": []
  },
  {
    name: "Division",
    fieldId: "requestedDivision",
    required: true,
    helperText: "",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  }
]

const DEFAULT_TEAM_FIELDS = [
  {
    "name" : "Team Name",
    "fieldId" : "teamName",
    "required" : true,
    "helperText" : "",
    "include" : true,
    "fieldType" : "textbox",
    "primitiveType" : "string",
    "error" : {
        "name" : "",
        "helperText" : ""
    },
    "options": []
  },
  {
    name: "Event",
    fieldId: "requestedContest",
    required: true,
    helperText: "",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Division",
    fieldId: "requestedDivision",
    required: true,
    helperText: "",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  }
]

const DEFAULT_MANAGER_FIELDS = [
  {
    name: "First Name",
    fieldId: "first_name",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Last Name",
    fieldId: "last_name",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Email",
    fieldId: "email",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Phone",
    fieldId: "phone",
    required: true,
    helperText: "",
    include: true,
    fieldType: "phone",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Title",
    fieldId: "title",
    required: true,
    helperText: "Coach, Assistant Coach, Team Manager, etc",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: COACH_TITLE_OPTIONS
  }
]

const DEFAULT_TEAM_REPRESENTATIVE_FIELDS = [
  {
    name: "First Name",
    fieldId: "first_name",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Last Name",
    fieldId: "last_name",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Email",
    fieldId: "email",
    required: true,
    helperText: "",
    include: true,
    fieldType: "text",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Phone",
    fieldId: "phone",
    required: true,
    helperText: "",
    include: true,
    fieldType: "phone",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: []
  },
  {
    name: "Title",
    fieldId: "title",
    required: true,
    helperText: "Team Representative, Parent Representative, etc",
    include: true,
    fieldType: "select",
    primitiveType: "string",
    error: {
      name: "",
      helperText: ""
    },
    options: TEAM_REPRESENTATIVE_TITLE_OPTIONS
  }
]

export {
  COACH_TITLE_OPTIONS,
  TEAM_REPRESENTATIVE_TITLE_OPTIONS,
  DEFAULT_TEAM_FIELDS,
  DEFAULT_SEASON_TEAM_FIELDS,
  DEFAULT_MANAGER_FIELDS,
  DEFAULT_TEAM_REPRESENTATIVE_FIELDS,
};
